export const getDetailsTabStyles = () => ({
    content: {
    },
});
